import * as React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import type { CustomField, IODataCustomValues } from '@sales-center/common'
import { GridCustomFieldValue } from '../../GridCustomFieldValue'

export function createCustomFieldColumns<T extends IODataCustomValues>(
  customFields: CustomField[],
) {
  const visibility = {}

  const cols = customFields.map<GridColDef>((f) => {
    const field = `customField${f.id}`
    visibility[field] = false

    return {
      field,
      sortable: false,
      headerName: f.name,
      type: f.type == 'Date' ? 'date' : undefined,
      renderCell: ({ value }) => <GridCustomFieldValue value={value} />,
      valueGetter: ({ row }) => {
        const { odataCustomFieldValues: values = [] } = row as T
        return values.find((x) => x.customFieldId === f.id)
      },
    }
  })

  return [cols, visibility] as const
}
